import Image from 'next/image';

import xw from 'xwind';
import {
  Button,
  Description,
  ImagesWrapper,
  Text,
  Title,
  Tools,
} from './CheckListItem.style';
import { CheckList } from './checkListType';

const CheckListItem = ({
  id,
  imageUrl,
  title,
  description,
  link,
}: CheckList): JSX.Element => {
  return (
    <Tools toolId={id}>
      <ImagesWrapper>
        {imageUrl && (
          <Image
            layout="responsive"
            objectFit="fill"
            width={430}
            height={564}
            src={imageUrl}
            alt={title}
            unoptimized
          />
        )}
      </ImagesWrapper>
      <Text toolId={id}>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <a href={link} target="_blank" rel="noopener noreferrer">
          <Button>
            <img
              src="/icons/download.svg"
              width={13.33}
              height={13.33}
              css={xw`mr-3.5`}
              alt={title}
            />
            Download
          </Button>
        </a>
      </Text>
    </Tools>
  );
};

export default CheckListItem;
